import httpInstance from "../httpInstance";
import { getCategoriesList } from "./getCategories";

export const postCategory = async (jwtToken: string, categoryName: string) => {
    let res: any;
    const endpoint = `resourceCategories/`;

    const config = {
        headers: {
            Authorization: jwtToken
        }
    };

    const body = {
        "name": categoryName,
    }

    await httpInstance.post(endpoint, body, config)
        .then((response) => {
            res = response;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const postCategoryImage = async (jwtToken: string, category_id: any, image: any) => {
    let res: any;
    const endpoint = `resourceCategoryImages/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        }
    };

    const data = new FormData();
    data.append("category_id", category_id);
    data.append("image", image);

    await httpInstance.post(endpoint, data, config)
        .then((response) => {
            res = response;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const processCategoryImage = async (jwtToken: string, categoryName: string, image: any) => {
    try {
        // Fetch categories and store the response
        const categoriesResponse = await getCategoriesList(jwtToken);
        const categories = categoriesResponse.data; // Assuming categoriesResponse contains the categories array
 
        // Find the category_id based on the categoryName
        const matchingCategory = categories.find((category: any) => category.name === categoryName);

        if (matchingCategory) {
            // Call postCategoryImage with the found category_id
            const postResponse = await postCategoryImage(jwtToken, matchingCategory.id, image);
        } else {
        }
    } catch (error) {
        console.error('Error:', error);
    }
}